module.exports = __webpack_public_path__ + "img/logo.3b920870.png";